import React from "react";
import { useAuth } from "../../provider/AuthProvider";
import UseTitle from "../../components/useTitle";
import "./SkillTemplateFull.scss";

const SkillTemplateFull = ({ skillTemplate, setIsUpdate, setIsDelete }) => {
  // Définition du titre de la page
  UseTitle("Compétence " + (skillTemplate?.name || ""));

  const { isAdmin } = useAuth();

  return (
    <>
      <div className="skill-template-full">
        <h1>{skillTemplate.name}</h1>

        <div className="section">
          <h3>Informations générales</h3>
          <p className="element">
            <em>Description : {skillTemplate.description || "-"}</em>
          </p>

          <p className="element">Surnom : {skillTemplate.nickname || "-"}</p>
        </div>

        <div className="section">
          <h3>Attributs</h3>
          <ul className="element">
            {skillTemplate.attributes.map((attribute) => (
              <li key={attribute.id}>{attribute.full_name}</li>
            ))}
          </ul>
        </div>

        <div className="section">
          <h3>Informations complémentaires</h3>
          <p className="element">
            Valeur de départ : {skillTemplate.value_start}
          </p>
          <p className="element">
            Pour la battaille : {(skillTemplate.for_battle && "Oui") || "Non"}
          </p>
          <p className="element">
            Activé par defaut :{" "}
            {(skillTemplate.is_active_default && "Oui") || "Non"}
          </p>
        </div>

        {isAdmin && (
          <div className="buttons">
            <button className="bt" onClick={() => setIsUpdate(true)}>
              Modifier
            </button>
            <button className="bt" onClick={() => setIsDelete(true)}>
              Supprimer
            </button>
          </div>
        )}
      </div>
    </>
  );
};

export default SkillTemplateFull;
